import { z } from 'zod';

export const reframeClipResponseSchema = z.object({
  verticalLocalPath: z.string(),
  fileSizeKb: z.number(),
});

export type IReframeClipResponse = z.infer<typeof reframeClipResponseSchema>;
